import { Component, OnInit } from '@angular/core';
import { DashboardSectionStatus } from '../dashboard.component';
import { ZenplansTestDataProviderService } from './../../services/zenplans-test-data-provider.service';
//import countries from '../../assets/data/countries.json';
import plantree from '../../../assets/data/plan-tree.json';

@Component({
  selector: 'app-my-dashboard-tab4',
  templateUrl: './my-dashboard-tab4.component.html',
  styleUrls: ['./my-dashboard-tab4.component.scss']
})
export class MyDashboardTab4Component implements OnInit {
  SectionTitle = "My Wishes"
  SectionStatus = DashboardSectionStatus
  WishesInfo = 'John, why no take a few minutes to review the items value listed in your plan?'

  WishesNumbers = [
    {
      circle: 'upToDate',
      number: 5,
      SectionStatus: DashboardSectionStatus[0]
    },
    {
      circle: 'toReview',
      number: 12,
      SectionStatus: DashboardSectionStatus[1]
    },
    {
      circle: 'toAdd',
      number: 13,
      SectionStatus: DashboardSectionStatus[2]
    },
  ]

  reviewStatusPerSection = [];
  constructor(private zenPlansData:ZenplansTestDataProviderService) { 
  }

  async ngOnInit() {
    let sectionStatus = await this.zenPlansData.getPlanCategoryStatus("my wishes");
    this.WishesNumbers[0].number= sectionStatus["upToDates"];
    this.WishesNumbers[1].number= sectionStatus["forReviews"];
    this.WishesNumbers[2].number= sectionStatus["missing"];
    this.reviewStatusPerSection = sectionStatus["reviewCodes"];
  }

  async getSectionStatus(){

  }

}
